import { useFormik } from "formik";
import apiRequest from "../../../../utils/admin/apiRequest";
import InputField from "../../../ui/form/InputField";
import Button from "../../../ui/utils/Button";
import Alert from "../../../ui/utils/Alert";
import {  useState } from "react";
import * as Yup from "yup";
import FileInputField from "../../../ui/form/FileInputField";
import axios from "axios";
import authManager from "../../../../utils/admin/authManager";
import DemoFile  from "../../../../assets/dinner.xlsx";

const ProductImport = ({ closeModal, callback }) => {
  const [preview, setPreview] = useState(null);
  const [progress, setProgress] = useState(0);
  const [serverError, setServerError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);






  const formik = useFormik({
    initialValues: {
      name: "",
      file: null,
      usertype: "vendor",
      adminId: "",
      vendorId: "",
      vendorManagerId: "",
      corporateAdminId: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      file: Yup.mixed()
        .required("Excel file is required")
        .test("fileType", "Only .xlsx or .xls files allowed", (value) =>
          value
            ? [
              "application/vnd.ms-excel",
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ].includes(value.type)
            : false
        ),
    }),
    onSubmit: async (values, { resetForm }) => {
      setServerError("");
      setSuccessMsg("");
      setProgress(0);
      setLoading(true);

      try {
        const formData = new FormData();
        formData.append("name", values.name);
        formData.append("adminId", values.adminId || "");
        formData.append("vendorId", values.vendorId || "");
        formData.append("vendorManagerId", values.vendorManagerId);
        formData.append("corporateAdminId", values.corporateAdminId);

        formData.append("file", values.file);
        const api = `${process.env.REACT_APP_BASE_URL}api/admin/v1/product/product-import`;
        const response = await axios.post(api, formData, {
          headers: {
            Authorization: `Bearer ${authManager.getAccessToken()}`,
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setProgress(percentCompleted);
          },
        });

        if (response.data?.response) {
          setSuccessMsg(
            `✅ Import successful! Inserted: ${response?.data?.result?.inserted || 0}, Updated: ${response?.data?.result?.updated || 0}`
          );
          resetForm();
          setPreview(null);
          setProgress(100);
          callback?.();
          //setTimeout(() => closeModal(), 1200);
        } else {
          setServerError(response.data?.message || "Import failed. Please check your file.");
        }
      } catch (error) {
        console.error("Error importing file:", error);
        const msg =
          error.response?.data?.message ||
          error.message ||
          "Something went wrong while importing.";
        setServerError(msg);
      } finally {
        setLoading(false);
      }
    },
  });



  return (
    <div>
      <div className="p-4 flex justify-between items-center gap-2">
        <h2 className=" text-lg font-semibold">📦 Import Products </h2>
        <a href={DemoFile} className="bg-green-200 rounded-md shadow px-3">Demo</a>
      </div>
      <div className="border-b" />

      <form onSubmit={formik.handleSubmit} className="text-sm">
        {serverError && <Alert message={serverError} type="error" />}
        {successMsg && <Alert message={successMsg} type="success" />}

        <div className="p-4 space-y-4">
          <InputField
            id="name"
            label="Excel Name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.name && formik.errors.name}
            placeholder="Enter Excel Name"
          />

          {/* <AsyncSearchSelect
              label="Vendor Manager"
              name="vendorManagerId"
              value={formik.values.vendorManagerId}
              onChange={formik.handleChange}
              fetchOptions={fetchVendors}
              placeholder="Search Vendor Manager"
              error={formik.touched.vendorManagerId && formik.errors.vendorManagerId}
              /> */}



          <div className="grid grid-cols-2 gap-2">

          </div>

          <FileInputField
            error={formik.touched.file && formik.errors.file}
            id="file"
            label="Upload Excel File"
            accept=".xls,.xlsx"
            onChange={(e) => {
              const file = e.currentTarget.files?.[0] || null;
              formik.setFieldValue("file", file);
              setPreview(file ? file.name : null);
            }}
          />
          {preview && <p className="mt-2 text-gray-600">📄 {preview}</p>}

          {progress > 0 && (
            <div className="w-full bg-gray-200 rounded-full h-3 mt-4">
              <div
                className="bg-blue-500 h-3 rounded-full text-center text-white text-xs"
                style={{ width: `${progress}%` }}
              >
                {progress}%
              </div>
            </div>
          )}
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Importing..."
            isLoading={loading}
          >
            Import
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ProductImport;
